import type { IMetadata } from '~/models/Metadata';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

/** The office's app metadata: parking types, adjustment reasons and the other server-side lists. */
export const getMetadata = async (): Promise<IMetadata> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.get<IMetadata>('/metadata', { headers });
  return data;
};
